import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_w2k829fkq5: FaireBrandEntity = {
  token: "b_w2k829fkq5",
  type: "brand",
  name: "SleepHabits",
  avatarUrl:
    "https://cdn.faire.com/fastly/735a2cb30cc6e8da69ab6f2b6d3c94c63710011d0803441d5c6ec0b9a182dd3c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5e10dce9f715ee3f4325fc92baab0fc1726762fef6eaeb41bf428f1736f34699.png",
  logoUrl:
    "https://cdn.faire.com/fastly/735a2cb30cc6e8da69ab6f2b6d3c94c63710011d0803441d5c6ec0b9a182dd3c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5e10dce9f715ee3f4325fc92baab0fc1726762fef6eaeb41bf428f1736f34699.png",
  location: "Hollywood, FL, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "We founded SleepHabits as a brother and sister after discovering firsthand how much breathing and sleep impact overall health.\n\nAs recovering mouth breathers, we began searching for natural ways to improve our sleep, energy, and recovery. What started as a personal journey quickly turned into a deeper commitment to learning better breathing and sleep habits—and sharing those tools with others.\n\nThat path led us to Sierra Sleep & Airway Wellness Center, where we connected through a breathing retreat inspired by the work of James Nestor. Together with airway and sleep specialists, we began rethinking how sleep support should work at the root level.\n\nThis collaboration led us to create a new approach to nighttime wellness, including the first nitric oxide–focused supplement designed specifically for sleep and recovery.\n\nAt SleepHabits, we believe better health starts with better habits. Our mission is to offer simple, natural solutions that help people breathe better, sleep deeper, and feel their best—night after night.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:38.029Z",
    importedBy: "entity-db-cli",
  },
};
